var _class, _descriptor, _descriptor2, _descriptor3, _LoginPasswordCreationInstructionsComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable ember/no-runloop */
import { action } from '@ember/object';
import OpenIdConnectButton from 'core/components/authentication/open-id-connect-button';
import WrLinkTo from 'ember-wiser/components/wr/link-to';
import { eq } from 'ember-truth-helpers';
import WrDivider from 'ember-wiser/components/wr/divider';
import WrForm from 'ember-wiser/components/wr/form';
import { run } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import emberSwal from 'ui-kit/utils/ember-swal';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let LoginPasswordCreationInstructionsComponent = (_class = (_LoginPasswordCreationInstructionsComponent = class LoginPasswordCreationInstructionsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "requestManager", _descriptor, this);
    _initializerDefineProperty(this, "proSanteConnect", _descriptor2, this);
    _initializerDefineProperty(this, "aphpConnectMedic", _descriptor3, this);
  }
  get atLeastOneOpenIdConnectServiceEnabled() {
    return this.proSanteConnect.isEnabled || this.aphpConnectMedic.isEnabled;
  }
  async sendInstructions() {
    if (!this.args.model.email) {
      run(() => {
        emberSwal.fire('Vous devez entrer un email');
      });
      return;
    }
    const data1 = JSON.stringify({
      auth: {
        email: this.args.model.email,
        user_type: this.args.userType
      }
    });
    await this.requestManager.request({
      url: '/api/v1/send_instructions',
      method: 'POST',
      body: data1
    });
    this.showDialog({
      title: 'Vous allez recevoir un email',
      text: "Si l’adresse mail renseignée correspond à un compte existant, vous recevrez un nouveau lien d'authentification sur cette même adresse.",
      icon: 'success'
    });
  }
  showDialog(options1, callbackAction1) {
    return run(() => {
      emberSwal.fire(options1).then(() => {
        run(() => {
          callbackAction1?.();
        });
      });
    });
  }
}, setComponentTemplate(precompileTemplate("\n    <div class=\"flex flex-col gap-6\">\n\n      <h2 class=\"text-h2 text-purple text-center font-sans\">\n        Cr\xE9er/r\xE9initialiser\n        <br />\n        votre mot de passe\n      </h2>\n\n      <WrForm @data={{@model}} @onSubmit={{this.sendInstructions}} class=\"mx-auto flex w-full flex-col items-center gap-6 sm:w-[400px]\" as |form|>\n        <form.Input @name=\"email\" aria-label=\"Votre adresse e-mail\" type=\"text\" placeholder=\"Votre adresse e-mail\" data-test-login=\"email\" />\n\n        <form.SubmitButton type=\"submit\" @icon=\"ArrowRight\">\n          Recevoir l'e-mail\n        </form.SubmitButton>\n\n        <p class=\"text-center\">\n          Nous allons vous envoyer un email contenant un lien qui vous permettra\n          de cr\xE9er votre mot de passe.\n          <br />\n          Si vous ne le recevez pas, pensez \xE0 v\xE9rifier vos spams.\n        </p>\n      </WrForm>\n\n      {{#if (eq @userType \"medic\")}}\n        {{#if this.atLeastOneOpenIdConnectServiceEnabled}}\n          <WrDivider>ou</WrDivider>\n\n          <OpenIdConnectButton @openIdConnectService={{this.proSanteConnect}} class=\"w-[220px] self-center\" />\n\n          <OpenIdConnectButton @openIdConnectService={{this.aphpConnectMedic}} class=\"self-center\" />\n        {{/if}}\n      {{else}}\n        <WrDivider>ou</WrDivider>\n\n        <WrLinkTo @route=\"login.patient-link\" class=\"text-center\">\n          Je re\xE7ois un lien de connexion\n        </WrLinkTo>\n      {{/if}}\n    </div>\n  ", {
  strictMode: true,
  scope: () => ({
    WrForm,
    eq,
    WrDivider,
    OpenIdConnectButton,
    WrLinkTo
  })
}), _LoginPasswordCreationInstructionsComponent), _LoginPasswordCreationInstructionsComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "requestManager", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "proSanteConnect", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "aphpConnectMedic", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sendInstructions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sendInstructions"), _class.prototype), _class);
export { LoginPasswordCreationInstructionsComponent as default };